import * as Utils from "./Utils";
import {decode as base64_decode} from "base-64";

class Role {
    permission = [];
    loginUserId = '';
    loginName = '';
    accessToken = '';
    agencyId = null;
    permissionId = 0;
    constructor() {
        let menuItems;
        let utmTokens = localStorage.getItem(Utils.LOCAL_STORAGE_KEY);
        if(utmTokens) {
            let jsonToken = JSON.parse(utmTokens);
            if(jsonToken.permission) {
                menuItems = jsonToken.permission.items;
                this.permissionId = jsonToken.permission.id;
            }
            if(jsonToken.id) {
                this.loginUserId = jsonToken.id;
            }
            if(jsonToken.contact) {
                this.loginName = jsonToken.contact;
            }
            if(jsonToken.agency) {
                if(jsonToken.agency.id) {
                    this.agencyId = jsonToken.agency.id;
                }
            }
            if(jsonToken.accessToken) {
                let jwt = jsonToken.accessToken;
                const decodedJwt = JSON.parse(base64_decode(jwt.split(".")[1]));
                if (decodedJwt.exp * 1000 < Date.now()) {
                    localStorage.removeItem(Utils.LOCAL_STORAGE_KEY);
                    window.location.href = '/';
                }
                this.accessToken = jsonToken.accessToken;
            }
            else {
                localStorage.removeItem(Utils.LOCAL_STORAGE_KEY);
                window.location.href = '/';
            }
        }

        let item = [];
        if(menuItems) {
            for(let rs of menuItems) {
                item[rs.menuId] = {
                    isView: rs.isView === 1,
                    isCreate: rs.isCreate === 1,
                    isEdit: rs.isEdit === 1,
                    isDelete: rs.isDelete === 1,
                    isShortLink: rs.isShortLink === 1
                };
            }
        }

        this.permission = item;
    }

    isView = (menuId) => {
        return this.permission[menuId] ? this.permission[menuId].isView : false;
    };

    isCreate = (menuId) => {
        return this.permission[menuId] ? this.permission[menuId].isCreate: false;
    };

    isEdit = (menuId) => {
        return this.permission[menuId] ? this.permission[menuId].isEdit: false;
    };

    isDelete = (menuId) => {
        return this.permission[menuId] ? this.permission[menuId].isDelete: false;
    };

    isShortLink = (menuId) => {
        return this.permission[menuId] ? this.permission[menuId].isShortLink: false;
    };
}
export default Role;